export default __webpack_public_path__ + "static/media/mondial-relay.e14853da.svg";